module.exports = __webpack_public_path__ + "static/media/improvement-idea-white.7cdeb14b.png";